export const jobIdArr = [
    {
        value: "lead",
        title: "ID lead",
        prefix: "",
        selected: false
    },
    {
        value: "fixed",
        title: "ID precio cerrado",
        prefix: "PC-",
        selected: true
    },
    
];
